import {
  Drawer,
  DrawerContent,
  useMediaQuery,
  useColorModeValue,
  useTheme,
  Button,
  IconButton,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/app.context";
import { MapContext } from "../context/map.context";
import BottomSheetWrapper from "./BottomSheetWrapper";
import FavouriteButton from "./FavouriteButton";
import { IoIosResize } from "react-icons/io";
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

type Props = {
  children: React.ReactNode;
  ml?: string
  hideExpand?: boolean
  expand?: boolean
  goBackUrl?: string
  showReturnBtn?: boolean
};

const BottomDrawer = ({ children, ml, hideExpand, expand, goBackUrl, showReturnBtn }: Props) => {

  const navigate = useNavigate()

  const [desktop] = useMediaQuery("(min-width: 1100px)");
  const { setOffset } = useContext(MapContext);
  const { goBack } = useContext(AppContext);
  const [expanded, setExpanded] = useState<boolean>(false)
  const theme = useTheme();
  const drawerBg = useColorModeValue("white", theme.colors?.["gray"]?.["900"]);

  // useEffect(() => {
  //   if (desktop) {
  //     setOffset([220, 0]);
  //     return () => setOffset([0, 0]);
  //   }
  // }, [desktop, setOffset]);

  useEffect(() => {
    if (expand){
      setExpanded(true)
    } else {
      setExpanded(false)
    }
  }, [expand])

  return (
    <Drawer
      size="sm"
      isOpen={true}
      onClose={() => null}
      trapFocus={false}
      placement="bottom"
      variant="alwaysOpen"
    >
      {showReturnBtn && <Button aria-label='Resize Drawer Window'
        zIndex={999}
        position="absolute"
        top={2}
        right={2}
        bg={"white"} // future work: change these hard coded values to work with dark mode
        color={"black"} // future work: change these hard coded values to work with dark mode
        leftIcon={<IoChevronBack/>}
        border={"1px solid black"}
        onClick={() => {goBackUrl ? navigate(`${goBackUrl}`) : goBack()}}
      >
        Return
      </Button>}
      <DrawerContent
        w={"lg"}
        maxW={"90%"}
        overflowX="hidden"
        overflowY={"auto"}
        position="relative"
        bg={drawerBg}
        p={"0 1em"}
        m={"0 auto"}
        mb={10}
        rounded="xl"
        maxH={expanded ? "22em" : "12em"}
      >
        {!hideExpand && <IconButton
          aria-label='Resize Drawer Window'
          zIndex={999}
          position="absolute"
          top={2}
          right={2}
          onClick={() => {setExpanded(!expanded)}}
          icon={<IoIosResize/>}
        />}
        {children}
      </DrawerContent>
    </Drawer>
  )
};

export default BottomDrawer;